import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as LeadStatusService from 'services/agents/lead/status';

export const useLeadStatusService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createLeadStatus = async (data, options = {}) => {
    const { error, payload: lead } = await LeadStatusService.create({
      ...options,
      data,
      token
    });

    if (error) {
      toast.error('Cannot create lead status at this time');
      return { lead_status: {} };
    }

    toast.success('Lead status created successfully.');
    return { lead_status: lead };
  };

  const deleteLeadStatus = async (id, options = {}) => {
    const { error } = await LeadStatusService.deleteOne(id, {
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to delete lead status at this time.');
      return false;
    }

    toast.success('Lead status deleted successfully');
    return true;
  };

  const fetchLeadStatus = async (id, options = {}) => {
    const { error, payload: lead } = await LeadStatusService.readById(id, { ...options, token });

    if (error) {
      toast.error(error);
      return { lead_status: null };
    }

    return { lead_status: lead };
  };

  const fetchLeadStatuses = async (options = {}) => {
    const { error, payload } = await LeadStatusService.read({ ...options, token });

    if (error) {
      toast.error(error);
      return { lead_statuses: [], size: 0 };
    }

    const {
      data: lead_statuses,
      meta: { size }
    } = payload;
    return { lead_statuses, size };
  };

  const searchLeadStatuses = async (keys, keyword, options = {}) => {
    const { error, payload } = await LeadStatusService.search(keys, keyword, {
      ...options,
      token
    });
    if (error) {
      toast.error('Unable to fetch lead statuses at this time.');
      return { lead_statuses: [], size: 0 };
    }

    const {
      data: lead_statuses,
      meta: { size }
    } = payload;
    return { lead_statuses, size };
  };

  const updateLeadStatus = async (id, options = {}) => {
    const { error } = await LeadStatusService.updateById(id, {
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to update lead status at this time.');
      return false;
    }

    toast.success('Lead status updated successfully');
    return true;
  };

  const reorderLeadStatuses = async (options = {}) => {
    const { error } = await LeadStatusService.reorder({
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to update lead statuses at this time.');
      return false;
    }

    toast.success('Lead statuses updated successfully');
    return true;
  };

  return {
    createLeadStatus,
    deleteLeadStatus,
    fetchLeadStatus,
    fetchLeadStatuses,
    reorderLeadStatuses,
    searchLeadStatuses,
    updateLeadStatus
  };
};
